import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isUndefined from 'lodash/isUndefined';
import isNull from 'lodash/isNull';
import { withRouter } from 'react-router-dom';
// import Image from 'react-image-resizer';
import { CircleContainerNew, Circle, Tick } from '../Journeys/styles';
// import { Layout, ArticleSection, Description, Button, ButtonContainer, ImageContainer, TitleContainer,ImageContainerIcons, AdminButtons } from './styles';
import { Button, ButtonContainer} from './styles';
import Waiting from '../Waiting';
import { ImageUrl } from '../../utils/constants';
import { getAdventureArticle, updateLockStatus, FetchQuizzes, SubmitQuiz, getFavoriteArticles, getRecommendedArticle, fetchsWellnessJourneysById } from '../../redux/actions';
// import AdventurePointDashBoard from'../AdventurePointDashBoard/index';
const PopUp = React.lazy(() => import('./popup'));
const ResultNew = React.lazy(() => import('./articleQuiz'));
import { getUserQuizScore } from '../../redux/actions';
import { withTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';
import parse from 'react-html-parser';
// import { ReportHeading } from '../UserProfile/styles';
import { ArchiveCategoryIcon, BackArrowFeed, EditIconBranding, FavouriteIcon, LikeIcon, RecognitionEyeIconNew, RestoreCategoryIcon } from '../../utils/icons';
import { ArticleContainer } from './styles';
import LazyImage from '../common/LazyImage/LazyImage';
import { showHideQuizResult } from '../../redux/actions/educationActions';
import { CardContainer, Title as RecommendedTitle } from '../AdventureCategories/styles';
import { NoComments } from '../SocialFeeds/styles';
import RelatedContent from './relatedContent';
import { FONT_SIZE_MAP, FONT_SIZE_OPTIONS } from '../../../mockData';
import { FontDropdown } from '../common/FontDropdown/FontDropdown';
import AudioPlayer from '../common/AudioPlayer/AudioPlayer';
import { ArchiveArticles, GetArticlesDetailsById, LikeUnlikeEducationPost, RestoreArticles, UpdateUserGlobalPoints } from '../../redux/constants/apiConstants';
import { fetchApi } from '../../utils/methods';
import { toast } from 'react-toastify';
import { WellnessHubHeading } from '../../containers/Education/styles';
import { CommonButtonPopup } from '../ReportsV2/styles';
import CommonModalNew from '../common/CommonModal/CommonModalNew';
// import styled from 'styled-components';
// const SanitizedDescription = styled.div``;

class Article extends Component {
  constructor() {
    super();
    this.descriptionRef = React.createRef();
    this.state = {
      save: 0,
      like: 0,
      showQuiz: false,
      archivePopUp: false,
      restorePopupOpen:false,
      showRestoreIcon:false,
      showResultPopUp: false,
      showResult: false,
      imagestatus: 0,
      selectedFont:localStorage.getItem("ARTICLE_FONT_SIZE_LABEL") || "Medium",
      journeyDetails:null
    }
  }
  
  componentDidMount() {
    const { match, fetchQuizzes, getUserQuizScore } = this.props;
    this.fetchArticleDetails(match.params.id)
    fetchQuizzes(match.params.id, 0);
    // this.updateUserPoints();
    getUserQuizScore(match.params.id);
    // fetchsWellnessJourneysById(match.params.id);
    // this.setSanitizedDescription();
    // fetchRecommendedArticles();
  }

  componentDidUpdate(prevProps) {
    const {  match, fetchQuizzes, getUserQuizScore } = this.props;
    if(prevProps?.match?.params?.id != match?.params?.id){
      this.fetchArticleDetails(match.params.id);
      fetchQuizzes(match.params.id, 0);
      // this.updateUserPoints();
      getUserQuizScore(match.params.id);
    }

  }
  fetchArticleDetails = async(id)=>{
    let apiUrl = GetArticlesDetailsById + "/" + id;
    try {
      const res = await fetchApi(apiUrl , "GET");
      if (res.status === "success") {
        this.setState({journeyDetails: res?.data?.article_details,relatedArticles:res?.data?.related_articles},()=>{this.updateUserPoints()});
        
        if(res?.data?.[0]?.deleted_at !== null){
          this.setState({showRestoreIcon:true})
        }else{
          this.setState({showRestoreIcon:false})
        }

      } else {
        toast.error(res?.data?.message || res.data?.[0]);
      }
    } catch (error) {
      window.console.error(error);
    }

  }

  handleFontChange = (option) => {
    this.setState({ selectedFont: option });

    // save label + actual size
    localStorage.setItem("ARTICLE_FONT_SIZE_LABEL", option);
    localStorage.setItem("ARTICLE_FONT_SIZE", FONT_SIZE_MAP[option]);
  };

  // componentDidUpdate(prevProps) {
  //   const { fetchAdventureArticle, match, fetchQuizzes, getUserQuizScore, fetchsWellnessJourneysById, journeyDetails,history } = this.props;
  //   if (prevProps?.journeyDetails?.description !== this.props?.journeyDetails?.description) {
  //     this.setSanitizedDescription();
  //   }

  //   const stringArray = history.location.pathname.split('/');
  //   const adventureId = stringArray[stringArray.length - 1];

  //   if(adventureId != journeyDetails?.id){
  //     fetchAdventureArticle(match.params.id, match.params.categoryName);
  //     fetchQuizzes(match.params.id, 0);
  //     this.updateUserPoints();
  //     getUserQuizScore(match.params.id);
  //     fetchsWellnessJourneysById(match.params.id);
  //     this.setSanitizedDescription();

  //   }
  // }

  // onSuccess = () =>{
  //   const { fetchAdventureArticle, match, getFavoriteArticles, fetchRecommendedArticles, fetchsWellnessJourneysById, journeyDetails} = this.props;
  //   fetchAdventureArticle(match.params.id, match.params.categoryName);
  //   getFavoriteArticles(10);
  //   fetchRecommendedArticles();
  //   !journeyDetails && fetchsWellnessJourneysById(match.params.id)
  // }

  updateUserPoints = () => {
    // const { updateUserGlobalPoints, /*journeyDetails,*/ updateLockStatus } = this.props;
    const {journeyDetails} = this.state;
    // journeyDetails && updateLockStatus(journeyDetails.id);
    // journeyDetails && updateUserGlobalPoints(journeyDetails.id, 7, this.onSuccess);
    journeyDetails && this.updateUserGlobalPoints(journeyDetails.id, 7);
  };

  updateUserGlobalPoints = async (actionId, activityType) => {
  
    const data = {
      action_id: actionId,
      activity_type: activityType,
    };
  
    try {
      const res = await fetchApi(UpdateUserGlobalPoints, "POST", data);
  
      if (res?.message) {
        toast.error(res.message);
      }
    } catch (error) {
      toast.error(error.message);
      window.console.error(error);
    }
  };
  

  // UNSAFE_componentWillReceiveProps(nextProps) {

  //   if ((this.props.journeyDetails !== nextProps.journeyDetails) && nextProps.journeyDetails){
  //     if(nextProps.journeyDetails && !nextProps.journeyDetails.read_status){
  //       nextProps.updateLockStatus(nextProps.journeyDetails.id);
  //       nextProps.updateUserGlobalPoints(nextProps.journeyDetails.id, 7, this.onSuccess)
  //     }
  //   }
  // }

  // componentWillUnmount() {
  //   const { getFavoriteArticles, fetchRecommendedArticles} = this.props;
  //   getFavoriteArticles(10);
  //   fetchRecommendedArticles();
  // }


  displayDeviceModal = () => {
    this.setState({ showQuiz: true })
  };

  displayResultModal = () => {
    const { /*journeyDetails,*/ getUserQuizScore } = this.props;
    const { journeyDetails } = this.state;
    getUserQuizScore(journeyDetails.id);
    this.setState({ showResult: true });
    this.props.showHideQuizResult(true);
  };

  hideResultModal = () => {
    this.setState({ showResult: false });
    this.props.showHideQuizResult(false);
    // this.onSuccess();
  };

  editJourney = () => {
    const { history, location, journeyDetails } = this.props;
    history.push({
      pathname: `${location.pathname}/edit`,
      state: { ...journeyDetails }
    });
  };
  
  navigateEdit = () => {
    const { history } = this.props;
    const {journeyDetails} = this.state;
    history.push({
      pathname: `/wellness-resources/edit-article/${journeyDetails.id}`,
      state: { ...journeyDetails }
    });
  }; 

  addQuiz = () => {
    const { history, location } = this.props;
    history.push({ pathname: `${location.pathname}/show-all-quiz` });
  }

  onSave = () => {
    this.setState({
      save: !this.state.save,
    })
  };

  saveImage = () => {
    this.setState({
      save: !this.state.save,
    })
  }


  addCategory = (categoryName, categories) => {
    let index = categories.findIndex((data) => data.category_name.toLowerCase() == categoryName.toLowerCase());
    return index != -1 ? categories[index].image : "test.png";
  };

  hideQuiz = () => {
    this.setState({ showQuiz: false });
  };

  setSanitizedDescription() {
    if (this.descriptionRef.current) {
      const sanitizedDescription = DOMPurify.sanitize(this.props?.journeyDetails?.description);
      const fragment = document.createRange().createContextualFragment(sanitizedDescription);
      while (this.descriptionRef.current.firstChild) {
        this.descriptionRef.current.removeChild(this.descriptionRef.current.firstChild);
      }
      this.descriptionRef.current.appendChild(fragment);
    }
  }

  restartQuiz=()=>{
    const{/*journeyDetails*/history}=this.props
    const { journeyDetails } = this.state;
    history.push(`/education/quizz/${journeyDetails?.id}`)
  }


  handleRestorePopup = () => {
    this.setState({restorePopupOpen:true});
    // setSelectedArticle(item);
  }

  handleRestorePopupClose = () => {
    this.setState({restorePopupOpen:false});
  }


  handleConfirmRestore = () => {
    this.RestoreCatgories();
    this.setState({restorePopupOpen:false});
  }

  handleArchivePopup = () => {
    this.setState({archivePopUp:true});
    // setSelectedArticle(item);
  }

  handleArchivePopupClose = () => {
    this.setState({archivePopUp:false});
  }


  handleConfirmArchive = () => {
    this.ArchiveCatgories();
  }



  RestoreCatgories = async()=>{
    const {journeyDetails} = this.state;
    const {history} = this.props;
    const categoryId = journeyDetails?.id;
    // const categoryId = selectedRecipe?.article_id; 
    let apiUrl =  RestoreArticles;
    try {
      const res = await fetchApi(apiUrl + "/" + categoryId, "POST");
      if(res.status === 'success'){
        toast.success(res.message);
        history.push(`/company/wellness`, {activeTab: "Archive",activeLibraryTab:"Articles"});
        if(res.data.deleted_at === null){
          this.setState({showRestoreIcon:false})
        }
        // setArchiveData(res.data[0].data)
      }else{
        toast.error((res?.message))
      }
    } catch (error) {
      window.console.error(error);
    }
  }


  ArchiveCatgories = async()=>{
    const {journeyDetails} = this.state;
    const {history} = this.props;

    const categoryId = journeyDetails?.id;
    
    try {
      const res = await fetchApi(ArchiveArticles + "/" + categoryId , "DELETE");
      if(res.status === 'success'){
        toast.success(res.message);
        this.setState({archivePopUp:false});
        history.push(`/company/wellness`, {activeTab: "Library",activeLibraryTab:"Articles"});

        if(res.data.deleted_at !== null){
          this.setState({showRestoreIcon:true})
        }
        // FetchRecentLaunchedData();  
        // setLaunchedArticles(res.data[0].data);
       
      }else{
        toast.error((res?.message))
      }
    } catch (error) {
      window.console.error(error);
    }
  }
  

  onClickFavoriteRibbon = async (type, typeId, likeStatus, favouriteStatus) => {
  
    const payload = {
      type,
      type_id: typeId,
      like_status: likeStatus,
      favorite_status:favouriteStatus
    };
  
    try {
      const res = await fetchApi("/" + LikeUnlikeEducationPost, "POST", payload);
  
      if (res.status === "success") {
        this.fetchArticleDetails(this.props.match?.params?.id)
        // Optimistic UI update
        toast.success(res?.data?.[0]);
        
      }else{

        toast.error(res?.data?.message)

      }
    } catch (error) {
      toast.error("Failed to update favourite");
    }
  };



  redirect = () => {
    const page = this.props.location?.state?.page;
    const libraryPage = this.props.location?.state?.libraryPage;
    if (page === "Articles") {
      this.props.history.push(
        "/company/wellness",
        { activeTab: "Archive", activeLibraryTab: "Articles" }
      );
    }else if (libraryPage === "Articles") {
      this.props.history.push(
        "/company/wellness",
        { activeTab: "Library", activeLibraryTab: "Articles" }
      );
    }
    else {
      this.props.history.goBack()}
  }




  render() {
    const { location, history, quizQuestions,onClickFavoriteRibbon, /*createOrUpdateQuiz,*/ role, /*updateArticle,*/ match, fetchAdventureArticle, fetchQuizzes, submitQuiz, userQuizScore, t,showQuizResult,/*recommendedArticle*/ } = this.props;
    const { save, like, showQuiz,/*showResult,*/ imagestatus,journeyDetails,archivePopUp,showRestoreIcon,restorePopupOpen,relatedArticles } = this.state;
    const stringArray = location.pathname.split('/');
    const adventureId = stringArray[stringArray.length - 1];
    if (!quizQuestions || isUndefined(journeyDetails) || isNull(journeyDetails) || (adventureId != (journeyDetails && journeyDetails.id)) || !role) {
      return <Waiting />
    }
    return (
      <>
        {/* <ReportHeading>
          <div className="icon" onClick={() => history.goBack()}>
            {BackArrowFeed('#DA6C74')}
          </div>
          <div className="title">{t(journeyDetails.category_name)} {t(journeyDetails.title)}</div>
        </ReportHeading> */}

        <WellnessHubHeading>
          <div className='right-row'>
            <div className="icon" onClick={this.redirect}>
              {BackArrowFeed('#DA6C74')}
            </div>
            <div className="title">{t(journeyDetails.category_name)}</div>
          </div>
          <div className="action-icons">
            {/* <div className="title">{t(journeyDetails.title)}</div> */}
            {role === "ADMIN" && ( showRestoreIcon ? <div className="edit-icon icon-background"  onClick={this.handleRestorePopup} >{RestoreCategoryIcon('#DA6C74')}</div> :<div className="edit-icon icon-background"  onClick={this.handleArchivePopup} >{ArchiveCategoryIcon('#DA6C74')}</div>)}
            {role === "ADMIN" && <div className="edit-icon "  onClick={this.navigateEdit}  /*onClick={() => history.push(`/wellness-resources/edit-article`)}*/ >{EditIconBranding('#DA6C74')}</div>}
          
          </div>
          <div className='left-row' style={{marginLeft:"12px"}}>
            {role === "ADMIN" && quizQuestions.length===0 &&
              <>
                {/* <CommonButtonPopup onClick={()=>history.push(`/education/adventure/${journeyDetails?.category_name?.toLowerCase()}/article/${journeyDetails?.id}/add-quiz`)}>
                  {t("Create Quiz")}
                </CommonButtonPopup> */}
                <CommonButtonPopup onClick={()=>history.push(`/wellness-resources/article/add-quiz/${journeyDetails?.id}`)}>
                  {t("Create Quiz")}
                </CommonButtonPopup>
              </>
            }
            {role === "ADMIN" && quizQuestions.length > 0 &&
              <>
                {/* <CommonButtonPopup onClick={()=>history.push(`/education/adventure/${journeyDetails?.category_name?.toLowerCase()}/article/${journeyDetails?.id}/add-quiz`)}>
                  {t("Create Quiz")}
                </CommonButtonPopup> */}
                {/* <CommonButtonPopup onClick={()=>history.push(`/wellness-resources/article/edit-quiz/${journeyDetails?.id}`)}>
                  {t("Edit Quiz")}
                </CommonButtonPopup> */}
              </>
            }
          </div>
        </WellnessHubHeading>

        <ArticleContainer>
          <div className="title">{t(journeyDetails.title)}</div>
          <LazyImage style={{width:'100%',height:'680px', borderRadius:'8px',objectFit:'cover'}}  src={`${ImageUrl}/${journeyDetails.image}`} />
          {journeyDetails?.audio_file ? <AudioPlayer src={ImageUrl + "/" + journeyDetails?.audio_file} title='audio' margin={"20px 0px"}/>:null}
          <div className='icon-container'>
            <div className='row-1'>
              <div className='icons like-container'>
                {/* {!imagestatus && (like || journeyDetails.like_status)? <LazyImage className={'image'} src="/public/images/NewDashboardV2/ColorLike.png" alt="like" onClick={() => this.addLike(journeyDetails)} />: <LazyImage className={'image'} src="/public/images/NewDashboardV2/like.png" alt="like" onClick={() => this.addLike(journeyDetails)} /> } */}

                <span style={{cursor:'pointer'}} onClick={() => this.onClickFavoriteRibbon("article", journeyDetails.id, journeyDetails.like_status ? 0 : 1, journeyDetails.favorite_status)} className='like-icon'>{<LikeIcon fill={!imagestatus && (like || journeyDetails.like_status)? "#DA6C74" : "none"}/>}</span>

                <span className='count'>{journeyDetails.likes_count}</span>
              </div>

              <div className='icons'>
                {/* {save !== 0 || journeyDetails?.favorite_status ?
                  <LazyImage className={'image'} src="/public/images/NewDashboardV2/ribbonColor.png" onClick={() => { onClickFavoriteRibbon("article", journeyDetails.id, 0, journeyDetails.favorite_status ? 0 : 1, 0); this.saveImage() }} /> :
                  <LazyImage className={'image'} src="/public/images/NewDashboardV2/ribbonNew.png" onClick={() => { onClickFavoriteRibbon("article", journeyDetails.id, 0, journeyDetails.favorite_status ? 0 : 1, 0); this.saveImage() }} />
                } */}

                <span style={{cursor:'pointer'}} onClick={() => { this.onClickFavoriteRibbon("article", journeyDetails.id, journeyDetails.like_status, journeyDetails.favorite_status ? 0 : 1, 0);}} className='like-icon'>{<FavouriteIcon fill={save !== 0 || journeyDetails?.favorite_status? "#DA6C74" : "none"}/>}</span>
                <span>  
                  <FontDropdown
                    options={FONT_SIZE_OPTIONS}
                    selectedOption={this.state.selectedFont}
                    setSelectedOption={this.handleFontChange}
                    dropdownHeight="auto"
                  />
                </span>
              </div>

            </div>

            <div className='row-2'>
              <div className='icons like-container'>
                <span className='like-icon'>{RecognitionEyeIconNew('#DA6C74')}</span>
                <span className='count'>{journeyDetails.seen_count}</span>
              </div>
              <div className='icons'>
                <CircleContainerNew marginRight={1} font={"14px"}>
                  <div className="flex">
                    <Circle borderColor="#DA6C74" checked={journeyDetails.read_status} width={'20px'} height={'20px'} borderWidth={'1px'}>
                      <Tick checked={journeyDetails.read_status} width={'7px'} height={'11px'} left={'6px'}/>
                    </Circle>
                  </div>
                  <div className="quiz">
                    {t("Article")}
                  </div>
                </CircleContainerNew>
                {quizQuestions && quizQuestions.length>0?<CircleContainerNew style={{ "marginLeft": "15px" }} font={"14px"}>
                  <div className="flex">
                    <Circle borderColor="#DA6C74" checked={journeyDetails.quiz_status} width={'20px'} height={'20px'} borderWidth={'1px'}>
                      <Tick checked={journeyDetails.quiz_status}width={'7px'} height={'11px'} left={'6px'}/>
                    </Circle>
                  </div>
                  <div className="quiz">
                    {t("Quiz")}
                  </div>
                </CircleContainerNew>:null}
              </div>
              
            </div>
          </div>


          <div className='desc' style={{ lineHeight:'unset',fontSize: FONT_SIZE_MAP[this.state.selectedFont] }}>{parse(journeyDetails?.description)}</div>

          <ButtonContainer>
            { journeyDetails.quiz_status || userQuizScore.quiz_status?
              <Button  onClick={() => this.displayResultModal()}>
                {t("Quiz Details")}
              </Button>:
              quizQuestions && quizQuestions.length===0?null:
                <Button 
                // onClick={() => quizQuestions && quizQuestions.length>0 && this.displayDeviceModal()}
                  onClick={()=>history.push({pathname:`/education/quizz/${journeyDetails?.id}`,state:{category:journeyDetails?.category_name}})}
                >
                  {/* <img src="/public/images/NewDashboardV2/tquizarrow.png" alt="back-arrow" /> */}
                  {t("Take Quiz")}
                </Button>}  
            <React.Suspense fallback={<Waiting/>}>
              <PopUp
                showModal={showQuiz}
                closeModal={this.hideQuiz}
                quetions={this.props.quizQuestions}
                adventureId={match.params.id}
                categoryName={journeyDetails?.category_name}
                fetchAdventureArticle={fetchAdventureArticle}
                fetchQuizzes={fetchQuizzes}
                submitQuiz={submitQuiz}
                adventureArticle={journeyDetails}
                quizQuestions={quizQuestions}
                history={history}
              />
            </React.Suspense>
            <React.Suspense fallback={<Waiting/>}>
              <ResultNew showModal={showQuizResult} closeModal={this.hideResultModal} restartQuiz={this.restartQuiz} userQuizScore={userQuizScore} />
            </React.Suspense>
          </ButtonContainer>

        </ArticleContainer>
        {/* <Layout>
          <div>
            <TitleContainer>
              <div>
                <div><img src={`${ImageUrl}/${journeyDetails.category_image}`} /></div>
                <span >{t(journeyDetails.category_name)}</span>
              </div>
              <div>
                <div>{t(journeyDetails.title)}</div>
                <div>
                  {save !== 0 || journeyDetails?.favorite_status ?
                    <img src="/public/images/NewDashboardV2/ribbonColor.png" onClick={() => { onClickFavoriteRibbon("article", journeyDetails.id, 0, journeyDetails.favorite_status ? 0 : 1, 0); this.saveImage() }} /> :
                    <img src="/public/images/NewDashboardV2/ribbonNew.png" onClick={() => { onClickFavoriteRibbon("article", journeyDetails.id, 0, journeyDetails.favorite_status ? 0 : 1, 0); this.saveImage() }} />
                  }
                </div>
              </div>
            </TitleContainer>
            <ArticleSection>
              <div style={{ "background": "white" }}>
                <ImageContainer >
                  <img src={`${ImageUrl}/${journeyDetails.image}`} width="100%" height="100%" />
                </ImageContainer>
                <ImageContainerIcons>
                  <div>
                    <div>
                      {!imagestatus && (like || journeyDetails.like_status)? <img src="/public/images/NewDashboardV2/ColorLike.png" alt="like" onClick={() => this.addLike(journeyDetails)} />:<img src="/public/images/NewDashboardV2/like.png" alt="like" onClick={() => this.addLike(journeyDetails)} /> }
                      {like ? <span>{journeyDetails.like_status ?((journeyDetails.likes_count) -1 ): ((journeyDetails.likes_count) + 1)}</span> : <span>{(journeyDetails.likes_count)}</span>}
                    </div>
   
                    <div>
                      <img src="/public/images/NewDashboardV2/view.png" alt="view" />
                      <span>{journeyDetails.seen_count}</span>
                    </div>
                  </div>
                  <div >
                    <CircleContainerNew marginRight={1} font={"14px"}>
                      <div className="flex">
                        <Circle borderColor="#DA6C74" checked={journeyDetails.read_status}>
                          <Tick checked={journeyDetails.read_status} />
                        </Circle>
                      </div>
                      <div className="quiz">
                        {t("Article")}
                      </div>
                    </CircleContainerNew>
                    {quizQuestions && quizQuestions.length>0?<CircleContainerNew style={{ "marginLeft": "15px" }} font={"14px"}>
                      <div className="flex">
                        <Circle borderColor="#DA6C74" checked={journeyDetails.quiz_status}>
                          <Tick checked={journeyDetails.quiz_status} />
                        </Circle>
                      </div>
                      <div className="quiz">
                        {t("Quiz")}
                      </div>
                    </CircleContainerNew>:null}
                  </div>
                </ImageContainerIcons>
              </div>
              <Description>
                <div>{parse(journeyDetails?.description)}</div>
                <ButtonContainer>
                  { journeyDetails.quiz_status || userQuizScore.quiz_status?
                    <Button  onClick={() => this.displayResultModal()} color={"#9FC989"}>
                      {t("Quiz Details")}
                    </Button>:
                    quizQuestions && quizQuestions.length===0?null:
                      <Button onClick={() => quizQuestions && quizQuestions.length>0 && this.displayDeviceModal()}>
                        <img src="/public/images/NewDashboardV2/tquizarrow.png" alt="back-arrow" />
                        {t("Take Quiz")}
                      </Button>}  
                  <React.Suspense fallback={<Waiting/>}>
                    <PopUp
                      showModal={showQuiz}
                      closeModal={this.hideQuiz}
                      quetions={this.props.quizQuestions}
                      adventureId={match.params.id}
                      categoryName={match.params.categoryName}
                      fetchAdventureArticle={fetchAdventureArticle}
                      fetchQuizzes={fetchQuizzes}
                      submitQuiz={submitQuiz}
                      adventureArticle={journeyDetails}
                      quizQuestions={quizQuestions}
                      history={history}
                    />
                  </React.Suspense>
                  <React.Suspense fallback={<Waiting/>}>
                    <ResultNew showModal={showResult} closeModal={this.hideResultModal} restartQuiz={this.restartQuiz} userQuizScore={userQuizScore} />
                  </React.Suspense>
                </ButtonContainer>
              </Description>
            </ArticleSection>
          </div>
          <div >
            {updateArticle &&
              <AdminButtons background={"#9FC989"} onClick={this.editJourney}>
                <div>
                  <img src="/public/images/NewDashboardV2/editarticle.png" alt="back-arrow" />
                </div>
                <div>
                  {t("Edit Article")}
                </div>
              </AdminButtons>
            }
            {createOrUpdateQuiz &&
              <AdminButtons background={"#69C2FF"} onClick={this.addQuiz}>
                <div>
                  <img src="/public/images/NewDashboardV2/showquiz.png" alt="back-arrow" />
                </div>
                <div>
                  {t("Show Quiz")}
                </div>
              </AdminButtons>
            }
            <AdventurePointDashBoard />
          </div>
        </Layout> */}

        <div>
          <RecommendedTitle videoCSS={1}>{t("Related Articles")}</RecommendedTitle>
          <CardContainer>
            {!relatedArticles?.length ? <NoComments>{t("No Related Articles")}</NoComments> :
              relatedArticles?.map((video, index) => (
                <RelatedContent video={video} key={index} history={history} bottom={"25px"} width={'calc((100% / 2) - 12.5px)'} onClickFavoriteRibbon={onClickFavoriteRibbon} />
              ))
            }
          </CardContainer>
        </div>

        {archivePopUp && <CommonModalNew
          show={archivePopUp}
          icon={ArchiveCategoryIcon("#184A61")}
          title="Archive Article"
          description="Are you sure you want to Archive this article?"
          subDescription="You can view the archived data in archive tab of wellness resources"
          onCancel={this.handleArchivePopupClose}
          onConfirm={this.handleConfirmArchive}
          cancelText="Keep Article"
          confirmButtonText="Archive"
          buttonIcon={ArchiveCategoryIcon("white")}
          modalHeight="261px"
          confirmButtonWidth="200px"
        />}

        {restorePopupOpen && <CommonModalNew
          show={restorePopupOpen}
          icon={RestoreCategoryIcon("#184A61")}
          title="Restore Article"
          description="Are you sure you want to restore this article?"
          subDescription="You can view these article in the category you have uploaded"
          onCancel={this.handleRestorePopupClose}
          onConfirm={this.handleConfirmRestore}
          cancelText="Keep Article"
          confirmButtonText="Restore"
          buttonIcon={RestoreCategoryIcon("white")}
          modalHeight="261px"
          confirmButtonWidth="200px"
        />}
        
      </>
    )
  }
}

Article.propTypes = {
  history: PropTypes.object.isRequired,
  fetchAdventureArticle: PropTypes.func.isRequired,
  adventureArticle: PropTypes.object,
  count: PropTypes.number,
  adventureIds: PropTypes.array,
  location: PropTypes.object.isRequired,
  updateUserGlobalPoints: PropTypes.func.isRequired,
  updateLockStatus: PropTypes.func.isRequired,
  role: PropTypes.string.isRequired,
  quizQuestions: PropTypes.array,
  fetchQuizzes: PropTypes.func.isRequired,
  submitQuiz: PropTypes.func.isRequired,
  match: PropTypes.object,
  updateArticle: PropTypes.bool,
  createOrUpdateQuiz: PropTypes.bool,
  onClickFavoriteRibbon: PropTypes.func,
  data: PropTypes.object,
  getUserQuizScore: PropTypes.func.isRequired,
  userQuizScore: PropTypes.object,
  getFavoriteArticles: PropTypes.func,
  fetchRecommendedArticles: PropTypes.func.isRequired,
  t: PropTypes.func,
  fetchsWellnessJourneysById: PropTypes.func,
  journeyDetails: PropTypes.array,
  showQuizResult:PropTypes.bool,
  showHideQuizResult:PropTypes.func,
  recommendedArticle:PropTypes.array,
};

const mapStateToProps = (state) => ({
  adventureArticle: state.education.adventureArticle,
  adventureIds: state.education.adventureIds,
  count: state.education.count,
  quizQuestions: state.education.quizQuestions,
  quizScore: state.education.quizScore,
  userQuizScore: state.education.userQuizScore,
  // journeyDetails: state.education.journeyDetails,
  showQuizResult:state.education.showQuizResult,
  recommendedArticle: state.education.recommendedArticle
});

const mapDispatchToProps = (dispatch) => ({
  fetchAdventureArticle: (id, category) => dispatch(getAdventureArticle(id, category)),
  updateLockStatus: (id) => dispatch(updateLockStatus(id)),
  fetchQuizzes: (id, value) => dispatch(FetchQuizzes(id, value)),
  submitQuiz: (data, categoryName, push) => dispatch(SubmitQuiz(data, categoryName, push)),
  getUserQuizScore: (id) => dispatch(getUserQuizScore(id)),
  getFavoriteArticles: (id) => dispatch(getFavoriteArticles(id)),
  fetchRecommendedArticles: () => dispatch(getRecommendedArticle()),
  fetchsWellnessJourneysById: (id) => dispatch(fetchsWellnessJourneysById(id)),
  showHideQuizResult: (showQuizResult) => dispatch(showHideQuizResult(showQuizResult)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Article)));